import {
  DOCUMENT_STATUS,
  DOCUMENT_TYPE,
  DOCUMENT_TYPE_GSTR6,
  NATURE_OF_SUPPLY_TYPE,
} from '@app/pages/private/gstr1/gstr1-view-uploads/constant';
import { UploadCategory } from '@app/types/gstr1.type';
import { environment } from '@env/environment';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const GET_INV_SECTION_LIST = [
  {
    name: 'dropdown1',
    options: [
      { label: 'B2B', value: 'B2B', checked: false },
      { label: 'CDNR', value: 'CDNR', checked: false },
      { label: 'EXP', value: 'EXP', checked: false },
      { label: 'CDNUR', value: 'CDNUR', checked: false },
    ],
  },
];

export const VIEW_UPLOAD_CATEGORY_LIST: UploadCategory[] = [
  {
    id: 'Tab1',
    label: 'Invoice level',
    value: null,
    action: 'Regular Transactions',
    downloadDeleteKey: 'Regular Transactions',
  },
  {
    id: 'Tab2',
    label: 'Supplies to small customers',
    value: 'B2CSA',
    action: null,
    downloadDeleteKey: 'B2CS',
  },
  {
    id: 'Tab3',
    label: 'Nil exempt non GST',
    value: 'BSA',
    action: null,
    downloadDeleteKey: 'Nil Exempt NonGST',
  },
  {
    id: 'Tab4',
    label: 'Advanced received tax paid',
    value: 'RVA',
    action: null,
    downloadDeleteKey: 'Advance Received',
  },
  {
    id: 'Tab6',
    label: 'Document details',
    value: 'DD',
    action: null,
    downloadDeleteKey: 'Document Details',
  },
  {
    id: 'Tab7',
    label: 'HSN summary',
    value: 'HSNSUMMARY',
    action: null,
    downloadDeleteKey: 'HSN SAC Summary',
  },
  {
    id: 'Tab8',
    label: 'Supplier ECOM transactions',
    value: 'SUPECOMA',
    action: null,
    downloadDeleteKey: 'TABLE14',
  },
  {
    id: 'Tab9',
    label: 'ECOM transactions AGG',
    value: 'ECOMURP',
    action: null,
    downloadDeleteKey: 'TABLE15AggData',
  },
  {
    id: 'Tab10',
    label: 'ECOM Invoice level transactions',
    value: 'ECOM',
    action: null,
    downloadDeleteKey: 'TABLE15ItemLevelData',
  },
];

export const ISD_KEYS = [
  { key: 'dty', value: 'Document Type' },
  { key: 'docnum', value: 'Document Number' },
  { key: 'docdt', value: 'Document Date' },
  { key: 'ctin', value: 'GSTIN of counterparty' },
  { key: 'cname', value: 'Name of counterparty' },
  { key: 'val', value: 'Total value', dateFormat: true },
  { key: 'gstinStatus', value: 'GSTN Status' },
  { key: 'err', value: 'Error/Warning' },
];

export const GSTR6_VIEW_CATEGORY_LIST = [
  {
    Id: 'GSTR6ViewTab1',
    Title: 'Invoice level input',
    value: null,
    Category: 'Invoice Level Transactions',
    downloadDeleteKey: 'Regular Transactions',
  },
  {
    Id: 'GSTR6ViewTab2',
    Title: 'ISD',
    value: 'ISD',
    Category: 'ISD',
    downloadDeleteKey: 'ISD',
    KeyMapper: ISD_KEYS,
  },
];

export const BS_KEYS = {
  B2CS: 'Tab2',
  NIL: 'Tab3',
  AT: 'Tab4',
  HSN: 'Tab7',
};
export const BS_KEYS_GSTR6 = {
  NIL: 'GSTR2ViewTab2',
  AT: 'GSTR2ViewTab3',
  HSN: 'GSTR2ViewTab6',
};

export const SUMMARY_INFO = [
  { label: 'Filing Period', value: 'fp' },
  { label: 'GSTIN', value: 'gstin' },
  { label: 'Aggregate Turnover in previous FY', value: 'annualTurnover' },
  { label: 'Aggregate Turnover from Apr- Jun.', value: 'quarterTurnover' },
];

export const SUMMARY_MAIN_HEADER = {
  NA3: ['1. B2B', '4A/B/C,6B/C', 'b2bSecSummary'],
  b2bSecSummary: [],
  NA4: ['2. B2CL', '5A/B', 'b2clSecSummary'],
  b2clSecSummary: [],
  NA5: ['3. B2C (Others)', '7', 'b2csSecSummary'],
  b2csSecSummary: [],
  NA6: ['4. Credit/Debit Notes (Registered)', '9B', 'cdnrSecSummary'],
  cdnrSecSummary: [],
  NA8: ['5. Credit/Debit Notes (Unregistered)', '9B', 'cdnurSecSummary'],
  cdnurSecSummary: [],
  NA10: ['6. Exports', '6A', 'expSecSummary'],
  expSecSummary: [],
  NA12: ['7. Advance Received', '11(I)A(1)/11(I)A(2)', 'atSecSummary'],
  atSecSummary: [],
  NA14: ['8. Advance Adjusted', '11(I)B(1)/11(I)B(2)', 'txpdSecSummary'],
  txpdSecSummary: [],
  NA16: ['9. NIL/Non-GST/Exempt Supplies.', '8A/B/C/D', 'nilSecSummary'],
  nilSecSummary: [],
  NA17: ['10. HSN Summary', '12', 'hsnSecSummary'],
  hsnSecSummary: [],
  NA18: ['11. Document Details', '13', 'docIssuedSecSummary'],
  docIssuedSecSummary: [],
  NA28: ['12. Ecom transactions reported by Supplier', '', 'supEcomSummary'],
  supEcomSummary: [],
  NA29: ['13. Ecom transactions reported by E-commerce operator', '', 'ecomSecSummary'],
  ecomSecSummary: [],
  NA19: ['14. 1A. B2B - Amendments', '9A', 'b2baSecSummary'],
  b2baSecSummary: [],
  NA20: ['15. 2A. B2CL - Amendments', '9A', 'b2claSecSummary'],
  b2claSecSummary: [],
  NA21: ['16. 3A. B2C (Others) - Amendments', '10', 'b2csaSecSummary'],
  b2csaSecSummary: [],
  NA22: ['17. 4A. Credit/Debit Notes (Registered) - Amendments', '9C', 'cdnraSecSummary'],
  cdnraSecSummary: [],
  NA23: [
    '18. 5A. Credit/Debit Notes (Unregistered) - Amendments',
    '9C',
    'cdnuraSecSummary',
  ],
  cdnuraSecSummary: [],
  NA24: ['19. Exports - Amendments', '', 'expaSecSummary'],
  expaSecSummary: [],
  NA25: ['20. Advance Received - Amendments', '11(II)A(1)/11(II)A(2)', 'ataSecSummary'],
  ataSecSummary: [],
  NA26: ['21. Advance Adjusted - Amendments', '11(II)B(1)/11(II)B(2)', 'txpdaSecSummary'],
  txpdaSecSummary: [],
  NA30: [
    '22. Amendment to Ecom transactions reported by Supplier',
    '',
    'supEcomASummary',
  ],
  supEcomASummary: [],
  NA31: [
    '23. Amendment to Ecom transactions reported by E-commerce operator',
    '',
    'ecomASecSummary',
  ],
  ecomASecSummary: [],
  NA27: ['24. Total Liability as per GSTN', '', 'liabilitySecSummary'],
  liabilitySecSummary: [],
};

export const SUMMARY_MAIN_HEADER_BEFORE_2024 = {
  NA2: [],
  NA3: ['1. B2B', '4A/B/C,6B/C', 'b2bSecSummary'],
  b2bSecSummary: [],
  NA4: ['2. B2CL', '5A/B', 'b2clSecSummary'],
  b2clSecSummary: [],
  NA5: ['3. B2C (Others)', '7', 'b2csSecSummary'],
  b2csSecSummary: [],
  NA6: ['4. Credit/Debit Notes (Registered)', '9B', 'cdnrSecSummary'],
  cdnrSecSummary: [],
  NA8: ['5. Credit/Debit Notes (Unregistered)', '9B', 'cdnurSecSummary'],
  cdnurSecSummary: [],
  NA10: ['6. Exports', '6A', 'expSecSummary'],
  expSecSummary: [],
  NA12: ['7. Advance Received', '11(I)A(1)/11(I)A(2)', 'atSecSummary'],
  atSecSummary: [],
  NA14: ['8. Advance Adjusted', '11(I)B(1)/11(I)B(2)', 'txpdSecSummary'],
  txpdSecSummary: [],
  NA16: ['9. NIL/Non-GST/Exempt Supplies.', '8A/B/C/D', 'nilSecSummary'],
  nilSecSummary: [],
  NA17: ['10. HSN Summary', '12', 'hsnSecSummary'],
  hsnSecSummary: [],
  NA18: ['11. Document Details', '13', 'docIssuedSecSummary'],
  docIssuedSecSummary: [],
  NA19: ['12. 1A. B2B - Amendments', '9A', 'b2baSecSummary'],
  b2baSecSummary: [],
  NA20: ['13. 2A. B2CL - Amendments', '9A', 'b2claSecSummary'],
  b2claSecSummary: [],
  NA21: ['14. 3A. B2C (Others) - Amendments', '10', 'b2csaSecSummary'],
  b2csaSecSummary: [],
  NA22: ['15. 4A. Credit/Debit Notes (Registered) - Amendments', '9C', 'cdnraSecSummary'],
  cdnraSecSummary: [],
  NA23: [
    '16. 5A. Credit/Debit Notes (Unregistered) - Amendments',
    '9C',
    'cdnuraSecSummary',
  ],
  cdnuraSecSummary: [],
  NA24: ['17. Exports - Amendments', '', 'expaSecSummary'],
  expaSecSummary: [],
  NA25: ['18. Advance Received - Amendments', '11(II)A(1)/11(II)A(2)', 'ataSecSummary'],
  ataSecSummary: [],
  NA26: ['19. Advance Adjusted - Amendments', '11(II)B(1)/11(II)B(2)', 'txpdaSecSummary'],
  txpdaSecSummary: [],
  NA27: ['20. Total Liability as per GSTN', '', 'liabilitySecSummary'],
  liabilitySecSummary: [],
};

export const SUMMARY_MAIN_HEADER_GSTR6 = {
  NA2: [''],
  NA3: ['1. B2B', '', 'b2bSummary'],
  b2bSummary: [],
  NA4: ['2. CDN', '', 'cdnSummary'],
  cdnSummary: [],
  NA27: ['3. B2BA', '', 'b2baSummary'],
  b2baSummary: [],
  NA28: ['4. CDNA', '', 'cdnaSummary'],
  cdnaSummary: [],
  NA00: ['ISD - Excluding Amendments', '', 'blank'],
  blank: [],
  NA5: ['5.  Eligible  - Registered ISD Invoices', '', 'eisdtSummary'],
  eisdtSummary: [],
  NA6: ['6. Eligible  - Registered ISD Credit Notes', '', 'eisdcntSummary'],
  eisdcntSummary: [],
  NA8: ['7. Eligible  - Unregistered ISD Invoices', '', 'eisdurtSummary'],
  eisdurtSummary: [],
  NA10: ['8. Eligible  - Unregistered ISD Credit Notes', '', 'eisdcnurtSummary'],
  eisdcnurtSummary: [],
  NA12: ['9. Ineligible  - Registered ISD Invoices', '', 'ieisdtSummary'],
  ieisdtSummary: [],
  NA14: ['10. Ineligible  - Registered ISD Credit Notes', '', 'ieisdcntSummary'],
  ieisdcntSummary: [],
  NA16: ['11. Ineligible  - Unregistered ISD Invoices', '', 'ieisdurtSummary'],
  ieisdurtSummary: [],
  NA18: ['12.  Ineligible  - Unregistered ISD Credit Notes', '', 'ieisdcnurtSummary'],
  ieisdcnurtSummary: [],
  NA01: ['ISD - Amendments', '', 'blank1'],
  blank1: [],
  NA19: ['13.  Eligible  - Registered ISD Invoices', '', 'eisdatSummary'],
  eisdatSummary: [],
  NA20: ['14. Eligible  - Registered ISD Credit Notes', '', 'eisdcnatSummary'],
  eisdcnatSummary: [],
  NA21: ['15. Eligible  - Unregistered ISD Invoices', '', 'eisduratSummary'],
  eisduratSummary: [],
  NA22: ['16. Eligible  - Unregistered ISD Credit Notes', '', 'eisdcnuratSummary'],
  eisdcnuratSummary: [],
  NA23: ['17. Ineligible  - Registered ISD Invoices', '', 'ieisdatSummary'],
  ieisdatSummary: [],
  NA24: ['18. Ineligible  - Registered ISD Credit Notes', '', 'ieisdcnatSummary'],
  ieisdcnatSummary: [],
  NA25: ['19. Ineligible  - Unregistered ISD Invoices', '', 'ieisduratSummary'],
  ieisduratSummary: [],
  NA26: ['20. Ineligible  - Unregistered ISD Credit Notes', '', 'ieisdcnuratSummary'],
  ieisdcnuratSummary: [],
};

export const GSTR6b2bSecSummary = {
  invoiceCount: 'Record Count',
  totalInvValue: 'Total Value',
  totalTaxableValue: 'Total Taxable Value',
  totalTaxAmount: 'Total Tax Amt.',
  totalIGSTAmount: 'IGST Tax Amt',
  totalCGSTAmount: 'CGST Tax Amt',
  totalSGSTAmount: 'SGST Tax Amt',
  totalCESSAmount: 'Cess Tax Amt',
};

export const SUMMARY_TABLE_NAME_GSTR6 = {
  b2bSummary: GSTR6b2bSecSummary,
  cdnSummary: GSTR6b2bSecSummary,
  b2baSummary: GSTR6b2bSecSummary,
  cdnaSummary: GSTR6b2bSecSummary,
  eisdtSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  eisdcntSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  eisdurtSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  eisdcnurtSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  ieisdtSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  ieisdcntSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  ieisdurtSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  ieisdcnurtSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  eisdatSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  eisdcnatSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  eisduratSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  eisdcnuratSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  ieisdatSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  ieisdcnatSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  ieisduratSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
  ieisdcnuratSummary: {
    invoiceCount: 'Record Count',
    totalTaxAmount: 'Total Tax Amt',
    totalIGSTAmount: 'Total Tax paid IGST',
    totalCGSTAmount: 'Total Tax paid CGST',
    totalSGSTAmount: 'Total Tax paid SGST',
    totalCESSAmount: 'Total Tax paid CESS',
  },
};

export const b2bSecSummaryKeys = {
  invoiceCount: 'Record Count',
  totalInvValue: 'Total Invoice Value',
  totalTaxableValue: 'Total Taxable Value',
  totalTaxableAmt: 'Total Tax Amt.',
  totalIGSTAmount: 'IGST',
  totalCGSTAmount: 'CGST',
  totalSGSTAmount: 'SGST',
  totalCESSAmount: 'Cess',
};

export const supEcomSummaryKeys = {
  invoiceCount: 'Record Count',
  totalInvVal: 'Total Value',
  totalTaxableValue: 'Total Taxable Value',
  totalTaxableAmt: 'Total Tax Amt.',
  totalIGSTAmount: 'IGST',
  totalCGSTAmount: 'CGST',
  totalSGSTAmount: 'SGST',
  totalCESSAmount: 'Cess',
};

export const ammendSecSummaryKeys = {
  invoiceCount: 'Record Count',
  totalInvValue: 'Total Actual Invoice Value',
  totalTaxableValue: 'Total Actual Taxable Value',
  totalTaxableAmt: 'Total Actual Tax Amt',
  totalIGSTAmount: 'Actual IGST',
  totalCGSTAmount: 'Actual CGST',
  totalSGSTAmount: 'Actual SGST',
  totalCESSAmount: 'Actual Cess',
  totalNetInvVal: 'Total Net Invoice Value',
  totalNetTaxValue: 'Total Net Taxable Value',
  totalNetTaxAmt: 'Total Net Tax Amt',
  netIGST: 'Net IGST',
  netCGST: 'Net CGST',
  netSGST: 'Net SGST',
  netCESS: 'Net Cess',
};

export const b2bHsnSummaryKeys = {
  invoiceCount: 'Record Count',
  totalInvValue: 'Total Value',
  totalTaxableValue: 'Total Taxable Value',
  totalTaxableAmt: 'Total Tax Amt.',
  totalIGSTAmount: 'IGST',
  totalCGSTAmount: 'CGST',
  totalSGSTAmount: 'SGST',
  totalCESSAmount: 'Cess',
};

export const SUMMARY_TABLE_NAME = {
  b2bSecSummary: b2bSecSummaryKeys,
  b2clSecSummary: b2bSecSummaryKeys,
  b2csSecSummary: {
    invoiceCount: 'Record Count',
    totalTaxableValue: 'Total Taxable Value',
    totalTaxableAmt: 'Total Tax Amt.',
    totalIGSTAmount: 'IGST',
    totalCGSTAmount: 'CGST',
    totalSGSTAmount: 'SGST',
    totalCESSAmount: 'Cess',
  },
  cdnrSecSummary: {
    invoiceCount: 'Record Count',
    totalTaxableValue: 'Total Taxable Value',
    totalTaxableAmt: 'Total Tax Amt.',
    totalIGSTAmount: 'IGST',
    totalCGSTAmount: 'CGST',
    totalSGSTAmount: 'SGST',
    totalCESSAmount: 'Cess',
  },
  cdnurSecSummary: {
    invoiceCount: 'Record Count',
    totalTaxableValue: 'Total Taxable Value',
    totalTaxableAmt: 'Total Tax Amt.',
    totalIGSTAmount: 'IGST',
    totalCESSAmount: 'Cess',
  },
  expSecSummary: {
    invoiceCount: 'Record Count',
    totalInvValue: 'Total Invoice Value',
    totalTaxableValue: 'Total Taxable Value',
    totalTaxableAmt: 'Total Tax Amt.',
    totalIGSTAmount: 'IGST',
  },
  atSecSummary: b2bSecSummaryKeys,
  txpdSecSummary: b2bSecSummaryKeys,
  nilSecSummary: {
    totalNilAmount: 'NIL',
    totalNonGstNgsupAmount: 'Non-GST',
    totalExemptedNgsupAmount: 'Exempt',
  },
  hsnSecSummary: b2bHsnSummaryKeys,
  docIssuedSecSummary: {
    totnum: 'Total Docs',
    cancel: 'Cancelled Docs',
    netIssue: 'Net Issued Docs',
  },
  b2baSecSummary: ammendSecSummaryKeys,
  b2claSecSummary: ammendSecSummaryKeys,
  b2csaSecSummary: ammendSecSummaryKeys,
  cdnraSecSummary: ammendSecSummaryKeys,
  cdnuraSecSummary: ammendSecSummaryKeys,
  expaSecSummary: ammendSecSummaryKeys,
  ataSecSummary: ammendSecSummaryKeys,
  txpdaSecSummary: ammendSecSummaryKeys,
  liabilitySecSummary: b2bSecSummaryKeys,
  supEcomSummary: supEcomSummaryKeys,
  ecomSecSummary: supEcomSummaryKeys,
  supEcomASummary: ammendSecSummaryKeys,
  ecomASecSummary: ammendSecSummaryKeys,
};

export const INVOICE_TABLE_TYPE = [
  { key: '  ', value: 'Summary' },
  { key: '4', value: 'B2B' },
  { key: '5', value: 'B2CL' },
  { key: '6', value: 'Export' },
  { key: '7', value: 'B2CS' },
  { key: '8', value: 'Nil exempted nonGST' },
  { key: '9', value: 'Amendment to table 4,5,6' },
  { key: '10', value: 'Amendment to table 7' },
  { key: '11(I)', value: 'Adv & tax paid original' },
  { key: '11(II)', value: 'Adv & tax paid amendment' },
  { key: '12', value: 'HSN summary' },
  { key: '13', value: 'Document summary' },
  { key: '14', value: 'Supplier Ecom Transactions' },
  { key: '14A', value: 'Amendment to Table 14' },
  { key: '15', value: 'Ecom transactions agg' },
  { key: '15A(I)', value: 'AMENDMENT TO TABLE 15 for Registered Recipients' },
  { key: '15A(II)', value: 'AMENDMENT TO TABLE 15 for Unregistered Recipients' },
];

export const B2B_SEC_GSTN_KEYS = [
  { id: 'ttl_rec', isCurrency: false },
  { id: 'ttl_val', isCurrency: true },
  { id: 'ttl_tax', isCurrency: true },
  { id: 'totalTaxAmt', isCurrency: true },
  { id: 'ttl_igst', isCurrency: true },
  { id: 'ttl_cgst', isCurrency: true },
  { id: 'ttl_sgst', isCurrency: true },
  { id: 'ttl_cess', isCurrency: true },
];

export const B2BCS_GSTN_KEYS = [
  { id: 'ttl_rec', isCurrency: false },
  { id: 'ttl_tax', isCurrency: true },
  { id: 'totalTaxAmt', isCurrency: true },
  { id: 'ttl_igst', isCurrency: true },
  { id: 'ttl_cgst', isCurrency: true },
  { id: 'ttl_sgst', isCurrency: true },
  { id: 'ttl_cess', isCurrency: true },
];

export const CDN_URGSTN_KEYS = [
  { id: 'ttl_rec', isCurrency: false },
  { id: 'ttl_tax', isCurrency: true },
  { id: 'totalTaxAmt', isCurrency: true },
  { id: 'ttl_igst', isCurrency: true },
  { id: 'ttl_cess', isCurrency: true },
];

export const EXPORTS_GSTN_KEYS = [
  { id: 'ttl_rec', isCurrency: false },
  { id: 'ttl_val', isCurrency: true },
  { id: 'ttl_tax', isCurrency: true },
  { id: 'totalTaxAmt', isCurrency: true },
  { id: 'ttl_igst', isCurrency: true },
];
export const NIL_GSTN_KEYS = [
  { id: 'ttl_nilsup_amt', isCurrency: true },
  { id: 'ttl_ngsup_amt', isCurrency: true },
  { id: 'ttl_expt_amt', isCurrency: true },
];
export const DOC_GSTN_KEYS = [
  { id: 'ttl_doc_issued', isCurrency: false },
  { id: 'ttl_doc_cancelled', isCurrency: false },
  { id: 'net_doc_issued', isCurrency: false },
];

export const EXPA_GSTN_KEYS = [
  { id: 'ttl_rec', isCurrency: false },
  { id: 'ttl_val', isCurrency: true },
  { id: 'ttl_tax', isCurrency: true },
  { id: '', isCurrency: true },
  { id: 'ttl_igst', isCurrency: true },
];

export const ECOM_KEYS = [
  { id: 'ttl_rec', isCurrency: false },
  { id: 'netVal', isCurrency: true },
  { id: 'netTax', isCurrency: true },
  { id: 'totalTaxAmt', isCurrency: true },
  { id: 'netIgst', isCurrency: true },
  { id: 'netCgst', isCurrency: true },
  { id: 'netSgst', isCurrency: true },
  { id: 'netCess', isCurrency: true },
];

export const TTL_LIABLITY_GSTN_KEYS = [
  { id: 'ttl_rec', isCurrency: false },
  { id: 'ttl_val', isCurrency: true },
  { id: 'ttl_tax', isCurrency: true },
  { id: 'totalTaxAmt', isCurrency: true },
  { id: 'ttl_igst', isCurrency: true },
  { id: 'ttl_cgst', isCurrency: true },
  { id: 'ttl_sgst', isCurrency: true },
  { id: 'ttl_cess', isCurrency: true },
];

export const SECTION_KEY_PAIR = {
  b2bSecSummary: 'B2B',
  b2baSecSummary: 'B2BA',
  b2clSecSummary: 'B2CL',
  b2claSecSummary: 'B2CLA',
  b2csSecSummary: 'B2CS',
  b2csaSecSummary: 'B2CSA',
  cdnrSecSummary: 'CDNR',
  cdnraSecSummary: 'CDNRA',
  atSecSummary: 'AT',
  txpdSecSummary: 'TXPD',
  hsnSecSummary: 'HSN',
  cdnurSecSummary: 'CDNUR',
  cdnuraSecSummary: 'CDNURA',
  expSecSummary: 'EXP',
  nilSecSummary: 'NIL',
  docIssuedSecSummary: 'DOC_ISSUE',
  expaSecSummary: 'EXPA',
  ataSecSummary: 'ATA',
  txpdaSecSummary: 'TXPDA',
  supEcomSummary: 'SUPECOM',
  ecomSecSummary: 'ECOM',
  supEcomASummary: 'SUPECOMA',
  ecomASecSummary: 'ECOMA',
  liabilitySecSummary: 'TTL_LIAB',
};

export const SECTION_KEY_PAIR_GSTR6 = {
  b2bSummary: 'B2BT',
  cdnSummary: 'CDNT',
  b2baSummary: 'B2BAT',
  cdnaSummary: 'CDNAT',
  eisdtSummary: 'EISDT',
  eisdcntSummary: 'EISDCNT',
  eisdurtSummary: 'EISDURT',
  eisdcnurtSummary: 'EISDCNURT',
  ieisdtSummary: 'IEISDT',
  ieisdcntSummary: 'IEISDCNT',
  ieisdurtSummary: 'IEISDURT',
  ieisdcnurtSummary: 'IEISDCNURT',
  eisdatSummary: 'EISDAT',
  eisdcnatSummary: 'EISDCNAT',
  eisduratSummary: 'EISDURAT',
  eisdcnuratSummary: 'EISDCNURAT',
  ieisdatSummary: 'IEISDAT',
  ieisdcnatSummary: 'IEISDCNAT',
  ieisduratSummary: 'IEISDURAT',
  ieisdcnuratSummary: 'IEISDCNURAT',
};

export const IRIS_TO_GSTN_SUMMARY_MAPPING: any = {
  invoiceCount: 'ttl_rec',
  totalInvValue: 'ttl_val',
  totalTaxableValue: 'ttl_tax',
  totalTaxableAmt: 'totalTaxAmt',
  totalIGSTAmount: 'ttl_igst',
  totalCGSTAmount: 'ttl_cgst',
  totalSGSTAmount: 'ttl_sgst',
  totalCESSAmount: 'ttl_cess',
  netIssue: 'net_doc_issued',
  cancel: 'ttl_doc_cancelled',
  totnum: 'ttl_doc_issued',
};
export const IRIS_TO_GSTN_SUMMARY_MAPPING_GSTR6: any = {
  invoiceCount: 'rc',
  totalInvValue: 'ttl_tax',
  totalTaxableValue: 'ttl_val',
  totalTaxableAmt: 'totalTaxAmt',
  totalIGSTAmount: 'ttl_txpd_igst',
  totalCGSTAmount: 'ttl_txpd_cgst',
  totalSGSTAmount: 'ttl_txpd_sgst',
  totalCESSAmount: 'ttl_txpd_cess',
  netIssue: 'net_doc_issued',
  cancel: 'ttl_doc_cancelled',
  totnum: 'ttl_doc_issued',
};
export const IRIS_TO_GSTN_SUMMARY_MAPPING_ECOM_KEYS: any = {
  invoiceCount: 'ttl_rec',
  totalInvValue: 'netVal',
  totalTaxableValue: 'netTax',
  totalTaxableAmt: 'totalTaxAmt',
  totalIGSTAmount: 'netIgst',
  totalCGSTAmount: 'netCgst',
  totalSGSTAmount: 'netSgst',
  totalCESSAmount: 'netCess',
};

export const API_IP_ADDRESS = '27.168.1.1';

export const GSTR6ReconScreens = [
  {
    key: 'B2B',
    value: 'B2B',
    header: '2 - B2B INVOICES',
    dst: 'O',
  },
  {
    key: 'CDN',
    value: 'CDN',
    header: '3 - CREDIT/DEBIT NOTES',
    dst: 'O',
  },
  {
    key: 'B2B',
    value: 'B2B',
    header: '4 - B2BA',
    dst: 'R',
  },
  {
    key: 'CDN',
    value: 'CDN',
    header: '5 - CDNA',
    dst: 'R',
  },
];

export const GSTR1CreateScreens = [
  { key: 'summary', value: 'Summary', header: 'Summary' },
  {
    key: '4',
    value: 'B2B',
    header: '4. Taxable outward supplies to a registered person',
  },
  {
    key: '5',
    value: 'B2CL',
    header:
      '5. Taxable outward inter-State supplies to un-registered persons where the invoice value is more than Rs 2.5 lakh',
  },
  { key: '6', value: 'Export', header: '6. Zero rated supplies and Deemed Exports - ' },
  {
    key: '7',
    value: 'B2CS',
    header:
      '7. Taxable supplies (Net of debit notes and credit notes) to unregistered persons',
  },
  {
    key: '8',
    value: 'Nil exempted nonGST',
    header: '8. Nil rated, exempted and non GST outward supplies',
  },
  {
    key: '9',
    value: 'Amendment to table 4,5,6',
    header:
      '9. Amendments to taxable outward supply details furnished in returns for earlier tax periods in Table 4, 5 and 6 [including debit notes, credit notes ]',
  },
  {
    key: '10',
    value: 'Amendment to table 7',
    header:
      '10. Amendments to taxable outward supplies to unregistered persons furnished in returns for earlier tax periods in Table 7.',
  },
  {
    key: '11(I)',
    value: 'Adv & tax paid original',
    header:
      '11(I). Consolidated Statement of Advances Received/Advance adjusted in the current tax period (Net of refund vouchers, if any)',
  },
  {
    key: '11(II)',
    value: 'Adv & tax paid amendment',
    header:
      '11(II). Consolidated Statement of Amendments to Advances Received/Advance adjusted information furnished in earlier tax period (Net of refund vouchers, if any)',
  },
  { key: '12', value: 'HSN summary', header: '12. HSN-wise summary of outward supplies' },
  {
    key: '13',
    value: 'Document summary',
    header: '13. Documents issued during the tax period',
  },
  {
    key: '14',
    value: 'Supplier Ecom Transactions',
    header:
      '14. Details of the supplies made through e-commerce operators on which e-commerce operators are liable to collect tax under section 52 of the acvt or liable to pay tax u/s 9(5) [Supplier to report]',
  },
  {
    key: '14A',
    value: 'Amendment to Table 14',
    header:
      '14A. Amendment to details of the supplies made through e-commerce operators on which e-commerce operators are liable to collect tax under section 52 of the acvt or liable to pay tax u/s 9(5) [Supplier to report]',
  },
  {
    key: '15',
    value: 'Ecom transactions agg',
    header:
      '15. Details of the supplies made through e-commerce operators on which e-commerce operator is liable to pay tax u/s 9(5) [e-commerce operator to report]',
  },
  {
    key: '15A(I)',
    value: 'AMENDMENT TO TABLE 15 for Registered Recipients',
    header:
      '15A(I). Details of the supplies made through e-commerce operators on which e-commerce operator is liable to pay tax u/s 9(5) [e-commerce operator to report for registered recipients]',
  },
  {
    key: '15A(II)',
    value: 'AMENDMENT TO TABLE 15 for Unregistered Recipients',
    header:
      '15A(II). Details of the supplies made through e-commerce operators on which e-commerce operator is liable to pay tax u/s 9(5) [e-commerce operator to report for unregistered recipients]',
  },
];

export const GSTR1ACreateScreens = [
  { key: 'summary', value: 'Summary', header: 'Summary' },
  {
    key: '4',
    value: 'B2B',
    header: '4. Taxable outward supplies to a registered person',
    tableTypes: [
      {
        text: '4A - B2B - Other Supplies',
        tableHeader:
          '4A - Supplies other than those attracting reverse charge (including supplies made through e-commerce operator attracting TCS)',
        tabValue: '4A',
        dataKeys: [
          { header: 'Invoice Type', key: 'invTyp', displayIndex: true },
          { header: 'GSTIN', key: 'ctin', showCtinModal: true },
          { header: 'Invoice Number', key: 'inum' },
          { header: 'Invoice Date', key: 'idt' },
          { header: 'Invoice Value', key: 'val', isCurrency: true },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Details', key: 'details' },
        ],
      },
      {
        text: '4B - B2B - Reverse Charge',
        tabValue: '4B',
        dataKeys: [
          { header: 'Invoice Type', key: 'invTyp', displayIndex: false },
          { header: 'GSTIN', key: 'ctin', showCtinModal: true },
          { header: 'Invoice Number', key: 'inum' },
          { header: 'Invoice Date', key: 'idt' },
          { header: 'Invoice Value', key: 'val', isCurrency: true },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
    ],
  },
  {
    key: '5',
    value: 'B2CL',
    tableTypes: [
      {
        text: '5A - B2CL - NON ECOM',
        tabValue: '5A',
        tableHeader:
          '5A - Outward supplies (including supplies made through e-commerce operator, rate wise)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Invoice Number', key: 'inum' },
          { header: 'Invoice Date', key: 'idt' },
          { header: 'Invoice Value', key: 'val', isCurrency: true },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
    ],
    header:
      '5. Taxable outward inter-State supplies to un-registered persons where the invoice value is more than Rs 2.5 lakh',
  },
  {
    key: '6',
    value: 'Export',
    tableTypes: [
      {
        text: '6A - Exports',
        tabValue: '6A',
        tableHeader: '6A - Exports',
        dataKeys: [
          { header: 'Invoice Number', key: 'inum' },
          { header: 'Invoice Date', key: 'idt' },
          { header: 'Invoice Value', key: 'val', isCurrency: true },
          { header: 'Export Type', key: 'invTyp' },
          { header: 'Port Code', key: 'sbpcode' },
          { header: 'Bill No.', key: 'sbnum' },
          { header: 'Bill Date', key: 'sbdt' },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
      {
        text: '6B - SEZ',
        tabValue: '6B',
        tableHeader: '6B - Supplies made to SEZ unit or SEZ Developers',
        dataKeys: [
          { header: 'GSTIN', key: 'ctin', showCtinModal: true },
          { header: 'Invoice Number', key: 'inum' },
          { header: 'Invoice Date', key: 'idt' },
          { header: 'Invoice Value', key: 'val', isCurrency: true },
          { header: 'Export Type', key: 'invTyp' },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
      {
        text: '6C - DE',
        tabValue: '6C',
        tableHeader: '6C - Deemed exports',
        dataKeys: [
          { header: 'GSTIN', key: 'ctin', showCtinModal: true },
          { header: 'Invoice Number', key: 'inum' },
          { header: 'Invoice Date', key: 'idt' },
          { header: 'Invoice Value', key: 'val', isCurrency: true },
          { header: 'Export Type', key: 'invTyp' },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
    ],
    header: '6. Zero rated supplies and Deemed Exports - ',
  },
  {
    key: '7',
    value: 'B2CS',
    tableTypes: [
      {
        text: '7A - B2CS - INTRASTATE',
        tabValue: '7A',
        tableHeader:
          '7A - Intra-State supplies consolidated rate wise outward supplies (including supplies made through e-commerce operator attracting TCS)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Difference %', key: 'diffPercent', isPercentage: true },
          { header: 'Ecom Operator', key: 'etin' },
          { header: 'Type', key: 'typ' },
          { header: 'Rate', key: 'rt' },
          { header: 'Taxable Value', key: 'txval', isCurrency: true },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true },
        ],
      },
      {
        text: '7B - B2CS - INTERSTATE',
        tabValue: '7B',
        tableHeader:
          '7B - Inter-State Supplies where invoice value is upto Rs 2.5 Lakh (Rate wise)-Consolidated rate wise outward supplies (including supplies made through e-commerce operator attracting TCS)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Difference %', key: 'diffPercent', isPercentage: true },
          { header: 'Ecom Operator', key: 'etin' },
          { header: 'Type', key: 'typ' },
          { header: 'Rate', key: 'rt' },
          { header: 'Taxable Value', key: 'txval', isCurrency: true },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true },
        ],
      },
    ],
    header:
      '7. Taxable supplies (Net of debit notes and credit notes) to unregistered persons',
  },
  {
    key: '8',
    value: 'Nil exempted nonGST',
    tableTypes: [
      {
        text: '',
        tabValue: '8',
        dataKeys: [
          { header: 'Description', key: 'sply_ty', customFunction: 'getDescription' },
          { header: 'Nil Rated Supplies', key: 'nil_amt', isCurrency: true },
          {
            header: 'Exempted (other than nil rated/non GST supply)',
            key: 'expt_amt',
            isCurrency: true,
          },
          { header: 'Non-GST supplies', key: 'ngsup_amt', isCurrency: true },
        ],
      },
    ],
    header: '8. Nil rated, exempted and non GST outward supplies',
  },
  {
    key: '9',
    value: 'Amendment to table 4,5,6',
    tableTypes: [
      {
        text: '9A - AMD TABLE 4,5,6',
        tabValue: '9A',
        tableHeader: '9A - Amendment of invoice/Shipping bill details furnished earlier',
        dataKeys: [
          { header: 'Invoice Type', key: 'invTyp' },
          { header: 'GSTIN', key: 'gstin' },
          { header: 'Invoice Number', key: 'inum' },
          { header: 'Invoice Date', key: 'idt', isRightAligned: true },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Invoice Value', key: 'val', isCurrency: true, isRightAligned: true },
        ],
      },
      {
        text: '9B - CDN',
        tabValue: '9B',
        tableHeader: '9B - Debit Notes/Credit Notes',
        dataKeys: [
          { header: 'Counter party GSTIN', key: 'ctin', showCtinModal: true },
          { header: 'Credit/debit note type/ refund voucher', key: 'dty' },
          { header: 'Credit note/debit note / refund voucher number', key: 'inum' },
          {
            header: 'Credit note/debit note/ refund voucher date',
            key: 'idt',
            isRightAligned: true,
          },
          { header: 'Reason for issuing Dr./ Cr. notes', key: 'rsn' },
          { header: 'Pre GST regime Dr./ Cr. notes', key: 'pgst' },
          { header: 'Document number', key: 'refInum' },
          { header: 'Document date', key: 'refIdt', isRightAligned: true },
          {
            header: 'Total Note Value',
            key: 'val',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Details', key: 'details', hasIcon: true },
        ],
      },
      {
        text: '9C- AMD CDN',
        tabValue: '9C',
        tableHeader: '9C - Debit Notes/Credit Notes',
        dataKeys: [
          { header: 'Invoice Type', key: 'invTyp' },
          { header: 'GSTIN', key: 'gstin' },
          { header: 'Invoice Number', key: 'inum' },
          { header: 'Invoice Date', key: 'idt', isRightAligned: true },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Invoice Value', key: 'val', isCurrency: true, isRightAligned: true },
        ],
      },
    ],
    header:
      '9. Amendments to taxable outward supply details furnished in returns for earlier tax periods in Table 4, 5 and 6 [including debit notes, credit notes ]',
  },
  {
    key: '10',
    value: 'Amendment to table 7',
    tableTypes: [
      {
        text: '10A- B2CS - INTRASTATE',
        tabValue: '10A',
        tableHeader:
          '10A - Consolidated rate wise outward supplies of Intra-state transactions - Amendment',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Original Month', key: 'omon' },
          { header: 'Difference %', key: 'diffPercent' },
          { header: 'Ecom Operator', key: 'etin' },
          { header: 'Type', key: 'typ' },
          { header: 'Rate', key: 'rt', isRightAligned: true },
          {
            header: 'Taxable Value',
            key: 'txval',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
      {
        text: '10B- B2CS - INTERSTATE',
        tabValue: '10B',
        tableHeader:
          '10B - Consolidated rate wise outward supplies of Inter-state transactions - Amendment',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Original Month', key: 'omon' },
          { header: 'Difference %', key: 'diffPercent' },
          { header: 'Ecom Operator', key: 'etin' },
          { header: 'Type', key: 'typ' },
          { header: 'Rate', key: 'rt', isRightAligned: true },
          {
            header: 'Taxable Value',
            key: 'txval',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
    ],
    header:
      '10. Amendments to taxable outward supplies to unregistered persons furnished in returns for earlier tax periods in Table 7.',
  },
  {
    key: '11(I)',
    value: 'Adv & tax paid original',
    tableTypes: [
      {
        text: '11(I)A1- ADV TAX - INTRA',
        tabValue: `11A1`,
        tableHeader: '11(I)A1 - Intra-State supplies (Rate Wise)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Difference %', key: 'diffPercent' },
          { header: 'Rate', key: 'rt', isRightAligned: true },
          {
            header: 'Taxable Value',
            key: 'adAmt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
      {
        text: '11(I)A2- ADV TAX - INTER',
        tabValue: `11A2`,
        tableHeader: '11(I)A2 - Inter-State Supplies (Rate Wise)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Difference %', key: 'diffPercent' },
          { header: 'Rate', key: 'rt', isRightAligned: true },
          {
            header: 'Taxable Value',
            key: 'adAmt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
      {
        text: '11(I)B1- TXP - INTRA',
        tabValue: `11B1`,
        tableHeader: '11(I)B1 - Intra-State supplies (Rate Wise)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Difference %', key: 'diffPercent' },
          { header: 'Rate', key: 'rt', isRightAligned: true },
          {
            header: 'Taxable Value',
            key: 'adAmt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
      {
        text: '11(I)B2- TXP - INTER',
        tabValue: `11B2`,
        tableHeader: '11(I)B2 - Inter-State Supplies (Rate Wise)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Difference %', key: 'diffPercent' },
          { header: 'Rate', key: 'rt', isRightAligned: true },
          {
            header: 'Taxable Value',
            key: 'adAmt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
    ],
    header:
      '11(I). Consolidated Statement of Advances Received/Advance adjusted in the current tax period (Net of refund vouchers, if any)',
  },
  {
    key: '11(II)',
    value: 'Adv & tax paid amendment',
    tableTypes: [
      {
        text: '11(II)A1- ADV TAX - INTRA',
        tabValue: `11IIA1`,
        tableHeader: '11(II)A1 - Intra-State supplies (Rate Wise)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Original Month', key: 'omon' },
          { header: 'Difference %', key: 'diffPercent' },
          { header: 'Rate', key: 'rt', isRightAligned: true },
          {
            header: 'Taxable Value',
            key: 'adAmt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
      {
        text: '11(II)A2- ADV TAX - INTER',
        tabValue: `11IIA2`,
        tableHeader: '11(II)A2 - Inter-State Supplies (Rate Wise)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Original Month', key: 'omon' },
          { header: 'Difference %', key: 'diffPercent' },
          { header: 'Rate', key: 'rt', isRightAligned: true },
          {
            header: 'Taxable Value',
            key: 'adAmt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
      {
        text: '11(II)B1- TXP - INTRA',
        tabValue: `11IIB1`,
        tableHeader: '11(II)B1 - Intra-State supplies (Rate Wise)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Original Month', key: 'omon' },
          { header: 'Difference %', key: 'diffPercent' },
          { header: 'Rate', key: 'rt', isRightAligned: true },
          {
            header: 'Taxable Value',
            key: 'adAmt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
      {
        text: '11(II)B2- TXP - INTER',
        tabValue: `11IIB2`,
        tableHeader: '11(II)B2 - Inter-State Supplies (Rate Wise)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Original Month', key: 'omon' },
          { header: 'Difference %', key: 'diffPercent' },
          { header: 'Rate', key: 'rt', isRightAligned: true },
          {
            header: 'Taxable Value',
            key: 'adAmt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
    ],
    header:
      '11(II). Consolidated Statement of Amendments to Advances Received/Advance adjusted information furnished in earlier tax period (Net of refund vouchers, if any)',
  },
  {
    key: '12',
    value: 'HSN summary',
    tableTypes: [
      {
        text: '',
        tabValue: '12',
        dataKeys: [
          { header: 'Sr. No.', key: 'num', isRightAligned: true },
          { header: 'HSN of Goods or Services', key: 'hsnSc', isRightAligned: true },
          { header: 'Description of goods sold', key: 'desc' },
          { header: 'UQC (Unit of Measure) of goods sold', key: 'uqc' },
          { header: 'Rate', key: 'rt', isRightAligned: true },
          { header: 'Quantity of goods sold', key: 'qty', isRightAligned: true },
          { header: 'Total Value', key: 'val', isCurrency: true, isRightAligned: true },
          {
            header: 'Taxable value',
            key: 'txval',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
    ],
    header: '12. HSN-wise summary of outward supplies',
  },
  {
    key: '13',
    value: 'Document summary',
    tableTypes: [
      {
        text: '',
        tabValue: '13',
        dataKeys: [
          { header: 'Document Number', key: 'doc_num' },
          { header: 'Nature of Document', key: 'natureOfDocument' },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
    ],
    header: '13. Documents issued during the tax period',
  },
  {
    key: '14',
    value: 'Supplier Ecom Transactions',
    tableTypes: [
      {
        text: '14 - SUPECO details for section 52',
        tabValue: `14ECOM52`,
        dataKeys: [
          { header: 'ECOM Operator', key: 'etin' },
          {
            header: 'Supplier Value',
            key: 'suppval',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
      {
        text: '14 - SUPECO details for section 9(5)',
        tabValue: `14ECOM95`,
        dataKeys: [
          { header: 'ECOM Operator', key: 'etin' },
          {
            header: 'Supplier Value',
            key: 'suppval',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
    ],
    header:
      '14. Details of the supplies made through e-commerce operators on which e-commerce operators are liable to collect tax under section 52 of the acvt or liable to pay tax u/s 9(5) [Supplier to report]',
  },
  {
    key: '14A',
    value: 'Amendment to Table 14',
    tableTypes: [
      {
        text: '14A - SUPECO details for section 52',
        tabValue: `14ECOM52A`,
        dataKeys: [
          { header: 'Original ECOM Operator', key: 'oetin' },
          { header: 'ECOM Operator', key: 'etin' },
          {
            header: 'Supplier Value',
            key: 'suppval',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
      {
        text: '14A - SUPECO details for section 9(5)',
        tabValue: `14ECOM95A`,
        dataKeys: [
          { header: 'Original ECOM Operator', key: 'oetin' },
          { header: 'ECOM Operator', key: 'etin' },
          {
            header: 'Supplier Value',
            key: 'suppval',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'IGST Amount', key: 'iamt', isCurrency: true, isRightAligned: true },
          { header: 'CGST Amount', key: 'camt', isCurrency: true, isRightAligned: true },
          { header: 'SGST Amount', key: 'samt', isCurrency: true, isRightAligned: true },
          { header: 'CESS Amount', key: 'csamt', isCurrency: true, isRightAligned: true },
        ],
      },
    ],
    header:
      '14A. Amendment to details of the supplies made through e-commerce operators on which e-commerce operators are liable to collect tax under section 52 of the acvt or liable to pay tax u/s 9(5) [Supplier to report]',
  },
  {
    key: '15',
    value: 'Ecom transactions agg',
    tableTypes: [
      {
        text: '15 - B2B',
        tabValue: `15B2B`,
        tableHeader: 'Ecom transactions from registered supplier to registered recipient',
        dataKeys: [
          { header: 'Supplier Invoice Number', key: 'inum' },
          { header: 'Supplier Invoice Date', key: 'idt', isRightAligned: true },
          {
            header: 'Supplier Invoice Value',
            key: 'val',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Place of Supply', key: 'pos' },
          { header: 'Invoice Type', key: 'invTyp' },
          { header: 'Original Invoice Number', key: 'oinum' },
          { header: 'Original Invoice Date', key: 'oidt', isRightAligned: true },
          { header: 'Supply Type', key: 'splyTy' },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
      {
        text: '15 - URP2B',
        tabValue: `15URP2B`,
        tableHeader:
          'Ecom transactions from unregistered supplier to registered recipient',
        dataKeys: [
          { header: 'Supplier Invoice Number', key: 'inum' },
          { header: 'Supplier Invoice Date', key: 'idt', isRightAligned: true },
          {
            header: 'Supplier Invoice Value',
            key: 'val',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Place of Supply', key: 'pos' },
          { header: 'Invoice Type', key: 'invTyp' },
          { header: 'Supply Type', key: 'splyTy' },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
      {
        text: '15 - B2C',
        tabValue: `15B2C`,
        tableHeader:
          'Ecom transactions from registered supplier to unregistered recipient',
        dataKeys: [
          { header: 'Supply Type', key: 'splyTy' },
          {
            header: 'Taxable Value of Goods or Service as per invoice',
            key: 'txval',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Rate as per invoice', key: 'rt', isRightAligned: true },
          {
            header: 'IGST Amount as per invoice',
            key: 'iamt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'SGST Amount as per invoice',
            key: 'camt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'CGST Amount as per invoice',
            key: 'samt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'CESS Amount as per invoice',
            key: 'csamt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Supplier GSTIN', key: 'stin' },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
        ],
      },
      {
        text: '15 - URP2C',
        tabValue: `15URP2C`,
        tableHeader:
          'Ecom transactions from unregistered supplier to unregistered recipient',
        dataKeys: [
          { header: 'Supply Type', key: 'splyTy' },
          {
            header: 'Taxable Value of Goods or Service as per invoice',
            key: 'txval',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Rate as per invoice', key: 'rt', isRightAligned: true },
          {
            header: 'IGST Amount as per Invoice',
            key: 'iamt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'CGST Amount as per Invoice',
            key: 'camt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'SGST Amount as per Invoice',
            key: 'samt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'CESS Amount as per Invoice',
            key: 'csamt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Supplier GSTIN', key: 'stin' },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
        ],
      },
    ],
    header:
      '15. Details of the supplies made through e-commerce operators on which e-commerce operator is liable to pay tax u/s 9(5) [e-commerce operator to report]',
  },
  {
    key: '15A(I)',
    value: 'AMENDMENT TO TABLE 15 for Registered Recipients',
    tableTypes: [
      {
        text: '15A(I) - B2BA',
        tabValue: `15A1B2BA`,
        tableHeader: '15A(I)- B2BA',
        dataKeys: [
          { header: 'Supplier Invoice Number', key: 'inum' },
          { header: 'Supplier Invoice Date', key: 'idt', isRightAligned: true },
          {
            header: 'Supplier Invoice Value',
            key: 'val',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Invoice Type', key: 'invTyp' },
          { header: 'Original Invoice Number', key: 'oinum' },
          { header: 'Original Invoice Date', key: 'oidt', isRightAligned: true },
          { header: 'Supply Type', key: 'splyTy' },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
      {
        text: '15A(II) - URP2BA',
        tabValue: `15A1URP2BA`,
        tableHeader: '15A(I)- URP2BA',
        dataKeys: [
          { header: 'Supplier Invoice Number', key: 'inum' },
          { header: 'Supplier Invoice Date', key: 'idt', isRightAligned: true },
          {
            header: 'Supplier Invoice Value',
            key: 'val',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Invoice Type', key: 'invTyp' },
          { header: 'Original Invoice Number', key: 'oinum' },
          { header: 'Original Invoice Date', key: 'oidt', isRightAligned: true },
          { header: 'Supply Type', key: 'splyTy' },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
    ],
    header:
      '15A(I). Details of the supplies made through e-commerce operators on which e-commerce operator is liable to pay tax u/s 9(5) [e-commerce operator to report for registered recipients]',
  },
  {
    key: '15A(II)',
    value: 'AMENDMENT TO TABLE 15 for Unregistered Recipients',
    tableTypes: [
      {
        text: '15A(II) - B2CA',
        tabValue: `15A1B2CA`,
        dataKeys: [
          { header: 'Supply Type', key: 'splyTy' },
          {
            header: 'Taxable Value of Goods or Service as per invoice',
            key: 'txval',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Rate as per invoice', key: 'rt', isRightAligned: true },
          {
            header: 'IGST Amount as per Invoice',
            key: 'iamt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'CGST Amount as per Invoice',
            key: 'camt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'SGST Amount as per Invoice',
            key: 'samt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'CESS Amount as per Invoice',
            key: 'csamt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Supplier GSTIN', key: 'stin' },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Original Month', key: 'omon' },
          { header: 'Original Supplier GSTIN', key: 'ostin' },
        ],
      },
      {
        text: '15A(II) - URP2CA',
        tabValue: `15A1URP2CA`,
        dataKeys: [
          { header: 'Supply Type', key: 'splyTy' },
          {
            header: 'Taxable Value of Goods or Service as per invoice',
            key: 'txval',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Rate as per invoice', key: 'rt', isRightAligned: true },
          {
            header: 'IGST Amount as per Invoice',
            key: 'iamt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'CGST Amount as per Invoice',
            key: 'camt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'SGST Amount as per Invoice',
            key: 'samt',
            isCurrency: true,
            isRightAligned: true,
          },
          {
            header: 'CESS Amount as per Invoice',
            key: 'csamt',
            isCurrency: true,
            isRightAligned: true,
          },
          { header: 'Supplier GSTIN', key: 'stin' },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Original Month', key: 'omon' },
        ],
      },
    ],
    header:
      '15A(II). Details of the supplies made through e-commerce operators on which e-commerce operator is liable to pay tax u/s 9(5) [e-commerce operator to report for unregistered recipients]',
  },
];

export const GSTR6CreateScreens = [
  { key: 'summary', value: 'Summary', header: 'Summary' },
  {
    key: 'GSTR6SummaryITC',
    value: 'GSTR6SummaryITC',
    header: 'CROSS ITC UTILIZATION (SOVOS)',
    tableTypes: [
      {
        text: '4A - B2B - Other Supplies',
        tableHeader:
          '4A - Supplies other than those attracting reverse charge (including supplies made through e-commerce operator attracting TCS)',
        tabValue: '4A',
        dataKeys: [
          { header: 'Invoice Type', key: 'invTyp', displayIndex: true },
          { header: 'GSTIN', key: 'ctin', showCtinModal: true },
          { header: 'Invoice Number', key: 'inum' },
          { header: 'Invoice Date', key: 'idt' },
          { header: 'Invoice Value', key: 'val', isCurrency: true },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Details', key: 'details' },
        ],
      },
      {
        text: '4B - B2B - Reverse Charge',
        tabValue: '4B',
        dataKeys: [
          { header: 'Invoice Type', key: 'invTyp', displayIndex: false },
          { header: 'GSTIN', key: 'ctin', showCtinModal: true },
          { header: 'Invoice Number', key: 'inum' },
          { header: 'Invoice Date', key: 'idt' },
          { header: 'Invoice Value', key: 'val', isCurrency: true },
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
    ],
  },
  {
    key: 'GSTR6GSTNITC',
    value: 'GSTR6GSTNITC',
    header: 'GET ITC (GSTN)',
    tableTypes: [
      {
        text: '5A - B2CL - NON ECOM',
        tabValue: '5A',
        tableHeader:
          '5A - Outward supplies (including supplies made through e-commerce operator, rate wise)',
        dataKeys: [
          { header: 'Place of Supply', key: 'pos', showStateText: true },
          { header: 'Invoice Number', key: 'inum' },
          { header: 'Invoice Date', key: 'idt' },
          { header: 'Invoice Value', key: 'val', isCurrency: true },
          { header: 'Details', key: 'details', showDetailsModal: true },
        ],
      },
    ],
  },
];

export const b2bSummaryGSTNKeys = [
  {
    id: 'ttl_rec',
    isCurrency: false,
  },
  {
    id: 'ttl_val',
    isCurrency: true,
  },
  {
    id: 'ttl_tax',
    isCurrency: true,
  },
  {
    id: 'totalTaxAmt',
    isCurrency: true,
  },
  {
    id: 'ttl_igst',
    isCurrency: true,
  },
  {
    id: 'ttl_cgst',
    isCurrency: true,
  },
  {
    id: 'ttl_sgst',
    isCurrency: true,
  },
  {
    id: 'ttl_cess',
    isCurrency: true,
  },
];

export const cDNRSecGSTNKeys = [
  {
    id: 'ttl_rec',
    isCurrency: false,
  },
  {
    id: 'ttl_tax',
    isCurrency: true,
  },
  {
    id: 'totalTaxAmt',
    isCurrency: true,
  },
  {
    id: 'ttl_igst',
    isCurrency: true,
  },
  {
    id: 'ttl_cgst',
    isCurrency: true,
  },
  {
    id: 'ttl_sgst',
    isCurrency: true,
  },
  {
    id: 'ttl_cess',
    isCurrency: true,
  },
];

export const cdnURGSTNKeys = [
  {
    id: 'ttl_rec',
    isCurrency: false,
  },
  {
    id: 'ttl_tax',
    isCurrency: true,
  },
  {
    id: 'totalTaxAmt',
    isCurrency: true,
  },
  {
    id: 'ttl_igst',
    isCurrency: true,
  },
  {
    id: 'ttl_cess',
    isCurrency: true,
  },
];

export const b2bASummaryGSTNKeys = [
  {
    id: 'ttl_rec',
    isCurrency: false,
  },
  {
    id: 'ttl_val',
    isCurrency: true,
  },
  {
    id: 'ttl_tax',
    isCurrency: true,
  },
  {
    id: 'totalTaxAmt',
    isCurrency: true,
  },
  {
    id: 'ttl_igst',
    isCurrency: true,
  },
  {
    id: 'ttl_cgst',
    isCurrency: true,
  },
  {
    id: 'ttl_sgst',
    isCurrency: true,
  },
  {
    id: 'ttl_cess',
    isCurrency: true,
  },
  {
    id: 'netVal',
    isCurrency: true,
  },
  {
    id: 'netTax',
    isCurrency: true,
  },
  {
    id: 'totalTaxAmtNet',
    isCurrency: true,
  },
  {
    id: 'netIgst',
    isCurrency: true,
  },
  {
    id: 'netCgst',
    isCurrency: true,
  },
  {
    id: 'netSgst',
    isCurrency: true,
  },
  {
    id: 'netCess',
    isCurrency: true,
  },
];

export const exportsGSTNKeys = [
  {
    id: 'ttl_rec',
    isCurrency: false,
  },
  {
    id: 'ttl_val',
    isCurrency: true,
  },
  {
    id: 'ttl_tax',
    isCurrency: true,
  },
  {
    id: 'totalTaxAmt',
    isCurrency: true,
  },
  {
    id: 'ttl_igst',
    isCurrency: true,
  },
];

export const getTable14ColHeader = {
  invoiceCount: 'Record Count',
  totalTaxableValue: 'Total Taxable Value',
  totalIGSTAmount: 'IGST',
  totalCGSTAmount: 'CGST',
  totalSGSTAmount: 'SGST',
  totalTaxableAmt: 'Total Tax Amt.',
  totalCESSAmount: 'Cess',
};

export const table14SupEcomKeys = [
  { id: 'ttl_rec', isCurrency: false },
  { id: 'ttl_tax', isCurrency: true },
  { id: 'ttl_igst', isCurrency: true },
  { id: 'ttl_cgst', isCurrency: true },
  { id: 'ttl_sgst', isCurrency: true },
  { id: 'ttl_taxAmt', isCurrency: true },
  { id: 'ttl_cess', isCurrency: true },
];
export const table15EcomKeys = [
  { id: 'ttl_rec', isCurrency: false },
  { id: 'netTax', isCurrency: true },
  { id: 'netIgst', isCurrency: true },
  { id: 'netCgst', isCurrency: true },
  { id: 'netSgst', isCurrency: true },
  { id: 'totalTaxAmt', isCurrency: true },
  { id: 'netCess', isCurrency: true },
];

export const STATE_CODES = {
  '01': 'Jammu & Kashmir',
  '02': 'Himachal Pradesh',
  '03': 'Punjab',
  '04': 'Chandigarh',
  '05': 'Uttarakhand',
  '06': 'Haryana',
  '07': 'Delhi',
  '08': 'Rajasthan',
  '09': 'Uttar Pradesh',
  '10': 'Bihar',
  '11': 'Sikkim',
  '12': 'Arunachal Pradesh',
  '13': 'Nagaland',
  '14': 'Manipur',
  '15': 'Mizoram',
  '16': 'Tripura',
  '17': 'Meghalaya',
  '18': 'Assam',
  '19': 'West Bengal',
  '20': 'Jharkhand',
  '21': 'Odisha',
  '22': 'Chhattisgarh',
  '23': 'Madhya Pradesh',
  '24': 'Gujarat',
  '25': 'Daman & Diu',
  '26': 'Dadra & Nagar Haveli',
  '27': 'Maharashtra',
  '29': 'Karnataka',
  '30': 'Goa',
  '31': 'Lakshdweep',
  '32': 'Kerala',
  '33': 'Tamil Nadu',
  '34': 'Pondicherry',
  '35': 'Andaman & Nicobar Islands',
  '36': 'Telengana',
  '37': 'Andhra Pradesh',
  '38': 'Ladakh',
  '98': 'Other Territory',
};

export const FP_DATA = {
  Mar: [],
  Feb: [],
  Jan: [],
  Dec: [],
  Nov: [],
  Oct: [],
  Sept: [],
  Aug: [],
  Jul: [],
  Jun: [],
  May: [],
  Apr: [],
};

export const invoiceText = [
  {
    key: '1',
    text: '',
    part: [{ key: 'B2B', value: 'Get B2B Invoices of GSTR2A' }],
    subheader: [''],
  },
  {
    key: '3',
    text: '',
    part: [{ key: 'B2BA', value: 'B2B amendments' }],
    subheader: ['5. B2BA'],
  },
  { key: '2', text: '', part: [{ key: 'CDN', value: 'CDN' }], subheader: [''] },
  {
    key: '4',
    text: '',
    part: [{ key: 'CDNA', value: 'CDN amendments' }],
    subheader: ['5. CDNA'],
  },
];

export const NIL_EXEMPT_DESCRIPTION = {
  INTRB2B: '8A. Inter-State supplies to registered persons',
  INTRAB2B: '8B. Intra-State supplies to registered persons',
  INTRB2C: '8C. Inter-State supplies to unregistered persons',
  INTRAB2C: '8D. Intra-State supplies to unregistered persons',
};

export const DOCUMENT_DETAILS_DESC = {
  '1': 'Invoices for outward supply',
  '2': 'Invoices for inward supply from unregistered person',
  '3': 'Revised Invoice',
  '4': 'Debit Note',
  '5': 'Credit Note',
  '6': 'Receipt voucher',
  '7': 'Payment Voucher',
  '8': 'Refund voucher',
  '9': 'Delivery Challan for job work',
  '10': 'Delivery Challan for supply on approval',
  '11': 'Delivery Challan in case of liquid gas',
  '12': 'Delivery Challan in cases other than by way of supply (excluding at S no. 9 to 11)',
};

export const SECTION_TYPES = [
  { id: 1, name: 'B2B', val: 'B2B' },
  { id: 2, name: 'EXP', val: 'EXP' },
  { id: 3, name: 'CDNR', val: 'CDNR' },
  { id: 4, name: 'CDNUR', val: 'CDNUR' },
];

export const reconFilterGstr1einvCDN = [
  {
    key: 'ctin',
    displayText: 'Counterparty GSTIN',
    filterText: 'CTIN',
    type: 'textField',
    isMultiple: true,
  },
  {
    key: 'docNo',
    displayText: 'Note Number',
    filterText: 'Note Number',
    type: 'textField',
    isMultiple: true,
  },
  {
    key: 'irnNo',
    displayText: 'IRN Number',
    filterText: 'IRN Number',
    type: 'textField',
    isMultiple: false,
  },
  {
    key: 'einvst',
    displayText: 'IRN Status',
    filterText: 'IRN Status',
    type: 'dropDown',
    isMultiple: false,
  },
  {
    key: 'adftst',
    displayText: 'Autodrafted Status',
    filterText: 'Autodrafted Status',
    type: 'dropDown',
    isMultiple: false,
  },
];

export const reconFilterGstr1einvB2b = [
  {
    key: 'ctin',
    displayText: 'Counterparty GSTIN',
    filterText: 'CTIN',
    type: 'textField',
    isMultiple: true,
  },
  {
    key: 'docNo',
    displayText: 'Document Number',
    filterText: 'Document Number',
    type: 'textField',
    isMultiple: true,
  },

  {
    key: 'irnNo',
    displayText: 'IRN Number',
    filterText: 'IRN Number',
    type: 'textField',
    isMultiple: false,
  },
  {
    key: 'einvst',
    displayText: 'IRN Status',
    filterText: 'IRN Status',
    type: 'dropDown',
    isMultiple: false,
  },
  {
    key: 'adftst',
    displayText: 'Autodrafted Status',
    filterText: 'Autodrafted Status',
    type: 'dropDown',
    isMultiple: false,
  },
];

export const RECON_FILTER_TYPES = ['MATCH', 'MISMATCH', 'ONLY IRN', 'NO IRN'];
export const RECON_FILTER_TYPE = [
  { id: 1, name: 'MATCH', val: 'MATCH' },
  { id: 2, name: 'MISMATCH', val: 'MISMATCH' },
  { id: 3, name: 'ONLY IRN', val: 'ONLY IRN' },
  { id: 4, name: 'NO IRN', val: 'NO IRN' },
];
export const IMSRECON_FILTER_TYPES = [
  'MATCH',
  'DEEMED MATCH',
  'INVOICE MISMATCH',
  'VALUE MISMATCH',
];
export const IMSRECON_FILTER_TYPE = [
  { id: 1, name: 'MATCH', val: 'MATCHED' },
  { id: 2, name: 'DEEMED MATCH', val: 'NOTMATCHED' },
  { id: 3, name: 'INVOICE MISMATCH', val: 'invoicemismatch' },
  { id: 4, name: 'VALUE MISMATCH', val: 'value mismatch' },
];

export const GSTR6_RECON_FILTER_TYPE = [
  { id: 1, name: 'MATCH', val: 'MATCHED' },
  { id: 2, name: 'MISMATCH', val: 'NOTMATCHED' },
  { id: 3, name: 'SUPPLIER ONLY', val: 'SUPPLIER ONLY' },
  { id: 4, name: 'PURCHASER ONLY', val: 'PURCHASER ONLY' },
];

export const HSNSUMMARY_SECTION = [
  { label: 'B2B', value: 'B2B', checked: true },
  { label: 'B2C', value: 'B2C', checked: true },
];

export const GSTR1_EINV_STATUS_POPUP_HEADER = {
  B2B: [
    { header: 'Fields', key: '', isCurrency: false },
    { header: 'Document Date', key: 'idt', isCurrency: false },
    { header: 'Invoice Type', key: 'irisInvTyp', isCurrency: false },
    { header: 'POS', key: 'pos', isCurrency: false },
    { header: 'RCM', key: 'rchrg', isCurrency: false },
    { header: 'Invoice Value', key: 'val', isCurrency: true },
    { header: 'Taxable Value', key: 'totalTaxVal', isCurrency: true },
    { header: 'IGST', key: 'totalIamt', isCurrency: true },
    { header: 'CGST', key: 'totalCamt', isCurrency: true },
    { header: 'SGST', key: 'totalSamt', isCurrency: true },
    { header: 'CESS', key: 'totalCsamt', isCurrency: true },
    { header: 'Ecom GSTIN', key: 'cfs', isCurrency: false },
    { header: 'Differential Percentage', key: 'cfsr1', isCurrency: false },
  ],
  CDNR: [
    { header: 'Fields', key: '', isCurrency: false },
    { header: 'Note Date', key: 'ntDt', isCurrency: false },
    { header: 'Note Type', key: 'irisDty', isCurrency: false },
    { header: 'Invoice Type', key: 'irisInvTyp', isCurrency: false },
    { header: 'POS', key: 'pos', isCurrency: false },
    { header: 'RCM', key: 'rchrg', isCurrency: false },
    { header: 'Invoice Value', key: 'val', isCurrency: true },
    { header: 'Taxable Value', key: 'totalTaxVal', isCurrency: true },
    { header: 'IGST', key: 'totalIamt', isCurrency: true },
    { header: 'CGST', key: 'totalCamt', isCurrency: true },
    { header: 'SGST', key: 'totalSamt', isCurrency: true },
    { header: 'CESS', key: 'totalCsamt', isCurrency: true },
    { header: 'Ecom GSTIN', key: 'cfs', isCurrency: false },
    { header: 'Differential Percentage', key: 'cfsr1', isCurrency: false },
    { header: 'Invoice Number', key: 'inum', isCurrency: false },
    { header: 'Invoice Date', key: 'idt', isCurrency: false },
  ],
  CDNUR: [
    { header: 'Fields', key: '', isCurrency: false },
    { header: 'Note Date', key: 'ntDt', isCurrency: false },
    { header: 'Note Type', key: 'irisDty', isCurrency: false },
    { header: 'Invoice Type', key: 'irisInvTyp', isCurrency: false },
    { header: 'Invoice Value', key: 'val', isCurrency: true },
    { header: 'Taxable Value', key: 'totalTaxVal', isCurrency: true },
    { header: 'IGST', key: 'totalIamt', isCurrency: true },
    { header: 'CESS', key: 'totalCsamt', isCurrency: true },
    { header: 'Shipping Bill No. or Bill of Export No', key: 'sbNum', isCurrency: false },
    {
      header: 'Shipping Bill Date. or Bill of Export Date',
      key: 'sbDt',
      isCurrency: false,
    },
    { header: 'Shipping Bill Port Code', key: 'sbpCode', isCurrency: false },
    { header: 'Invoice Number', key: 'inum', isCurrency: false },
    { header: 'Invoice Date', key: 'idt', isCurrency: false },
  ],
  EXP: [
    { header: 'Fields', key: '', isCurrency: false },
    { header: 'Document Date', key: 'idt', isCurrency: false },
    { header: 'Invoice Type', key: 'irisInvTyp', isCurrency: false },
    { header: 'Invoice Value', key: 'val', isCurrency: true },
    { header: 'Taxable Value', key: 'totalTaxVal', isCurrency: true },
    { header: 'IGST', key: 'totalIamt', isCurrency: true },
    { header: 'CESS', key: 'totalCsamt', isCurrency: true },
    { header: 'Shipping Bill No. or Bill of Export No', key: 'sbNum', isCurrency: false },
    {
      header: 'Shipping Bill Date. or Bill of Export Date',
      key: 'sbDt',
      isCurrency: false,
    },
    { header: 'Shipping Bill Port Code', key: 'sbpCode', isCurrency: false },
  ],
};

export const SUBMIT_CHECKLIST_ACTIONS = [
  {
    description: `Invoice with business rule error are not considered while creating GSTR-1. Do follow the following to resolve this issue:`,
    errorCodeName: 'IRIS_GST_UPLOAD_ERR',
  },
  { description: `1) Click on 'Discard Draft'`, errorCodeName: 'IRIS_GST_UPLOAD_ERR' },
  {
    description: `2) Make corrections to invoices with errors and re-upload them on ${environment.APP_NAME} portal`,
    errorCodeName: 'IRIS_GST_UPLOAD_ERR',
  },
  {
    description: `3) Click on 'Create GSTR-1' button on th GSTR1 tab`,
    errorCodeName: 'IRIS_GST_UPLOAD_ERR',
  },
  {
    description: `4) Click on 'Save data to GSTN' button to save invoices. Wait for the save request to complete. You can check status of invoices on the View tab.`,
    errorCodeName: 'IRIS_GST_UPLOAD_ERR',
  },

  {
    description: `Invoices returned with an error from GSTN errors on ${environment.APP_NAME} portal. Do follow the following to resolve this issue:`,
    errorCodeName: 'IRIS_GST_GSTN_ERR',
  },
  { description: `1) Click on 'Discard Draft'`, errorCodeName: 'IRIS_GST_GSTN_ERR' },
  {
    description: `2) Make corrections to invoices with errors and re-upload them on ${environment.APP_NAME} portal`,
    errorCodeName: 'IRIS_GST_GSTN_ERR',
  },
  {
    description: `3) Click on 'Create GSTR-1' button on th GSTR1 tab`,
    errorCodeName: 'IRIS_GST_GSTN_ERR',
  },
  {
    description: `4) Click on 'Save data to GSTN' button to save invoices. Wait for the save request to complete. You can check status of invoices on the View tab.`,
    errorCodeName: 'IRIS_GST_GSTN_ERR',
  },

  {
    description: `You might have added new Invoices to the system or deleted existing Invoices from the system and not saved to GSTN.`,
    errorCodeName: 'SAVED_INVOICES_ERR',
  },
  {
    description: `Click on 'Save Data to GSTN' button on the GSTR1 tab to save or delete the invoices. Wait for the save request to complete. You can check status of invoices on he View tab.`,
    errorCodeName: 'SAVED_INVOICES_ERR',
  },

  {
    description: `You might have added new records to the system and not saved to GSTN or some records are still having errors(${environment.APP_NAME}/GSTN). Do follow the following to resolve this issue:`,
    errorCodeName: 'B2CS_AGGREGATE_ERR',
  },
  { description: `1) Click on 'Discard Draft'`, errorCodeName: 'B2CS_AGGREGATE_ERR' },
  {
    description: `2) Make corrections to records with errors and re-upload them on ${environment.APP_NAME} portal`,
    errorCodeName: 'B2CS_AGGREGATE_ERR',
  },
  {
    description: `3) Click on 'Create GSTR-1' button on th GSTR1 tab`,
    errorCodeName: 'B2CS_AGGREGATE_ERR',
  },
  {
    description: `4) Click on 'Save data to GSTN' button to save records. Wait for the save request to complete. You can check status of records on the View tab.`,
    errorCodeName: 'B2CS_AGGREGATE_ERR',
  },

  {
    description: `You might have added new records to the system and not saved to GSTN or some records are still having errors(${environment.APP_NAME}/GSTN). Do follow the following to resolve this issue:`,
    errorCodeName: 'ADVANCE_AGGREGATE_ERR',
  },
  { description: `1) Click on 'Discard Draft'`, errorCodeName: 'ADVANCE_AGGREGATE_ERR' },
  {
    description: `2) Make corrections to records with errors and re-upload them on ${environment.APP_NAME} portal`,
    errorCodeName: 'ADVANCE_AGGREGATE_ERR',
  },
  {
    description: `3) Click on 'Create GSTR-1' button on th GSTR1 tab`,
    errorCodeName: 'ADVANCE_AGGREGATE_ERR',
  },
  {
    description: `4) Click on 'Save data to GSTN' button to save records. Wait for the save request to complete. You can check status of records on the View tab.`,
    errorCodeName: 'ADVANCE_AGGREGATE_ERR',
  },

  {
    description: `Mismatch could be due to one of the following reasons:`,
    errorCodeName: 'SUMMARY_MATCH_ERR',
  },
  {
    description: `A) After Saving to GSTN, errors might have come from GSTN for some invoices or records. User can rectify these errors.Do follow the following to resolve this issue:`,
    errorCodeName: 'SUMMARY_MATCH_ERR',
  },
  { description: `1) Click on 'Discard Draft'`, errorCodeName: 'SUMMARY_MATCH_ERR' },
  {
    description: `2) Make corrections to invoices with errors and re-upload them on ${environment.APP_NAME} portal`,
    errorCodeName: 'SUMMARY_MATCH_ERR',
  },
  {
    description: `3) Click on 'Create GSTR-1' button on th GSTR1 tab`,
    errorCodeName: 'SUMMARY_MATCH_ERR',
  },
  {
    description: `4) Click on 'Save data to GSTN' button to save invoices. Wait for the save request to complete. You can check status of invoices on the View tab.`,
    errorCodeName: 'SUMMARY_MATCH_ERR',
  },
  {
    description: `B) Some invoices or records might be saved at GSTN but were deleted by the user from ${environment.APP_NAME} portal and hence are in Marked for deletion state. Click on 'Save data to GSTN' button to save invoices. Wait for the save request to complete. You can check status of invoices on the View tab. `,
    errorCodeName: 'SUMMARY_MATCH_ERR',
  },

  {
    description: `HSN Summary is not uploaded or created yet.Do follow the following to resolve this issue:`,
    errorCodeName: 'HSN_BLANK_ERR',
  },
  { description: `1) Click on 'Discard Draft'`, errorCodeName: 'HSN_BLANK_ERR' },
  {
    description: `2) If the HSN Summary settings is user(i.e. aggregate) then upload the HSN Summary in the input format provided for the same and If the HSN summary settings is system, then upload the invoices again with HSN level data (HSN, unit and quantity).`,
    errorCodeName: 'HSN_BLANK_ERR',
  },
  {
    description: `3) Click on 'Create GSTR-1' button on th GSTR1 tab. In case if settings are system, then HSN summary will be  auto created.`,
    errorCodeName: 'HSN_BLANK_ERR',
  },
  {
    description: `4)Click on 'Save Data to GSTN' button on the GSTR1 tab to save HSN Summary. Wait for the save request to complete. You can check status of HSN Summary on the View tab.`,
    errorCodeName: 'HSN_BLANK_ERR',
  },

  {
    description: `Document Details is not uploaded or created yet.Do follow the following to resolve this issue:`,
    errorCodeName: 'DOC_DETAILS_BLANK_ERR',
  },
  { description: `1) Click on 'Discard Draft'`, errorCodeName: 'DOC_DETAILS_BLANK_ERR' },
  {
    description: `2) Upload the document details in the input format provided for the same. `,
    errorCodeName: 'DOC_DETAILS_BLANK_ERR',
  },
  {
    description: `3) Click on 'Create GSTR-1' button on th GSTR1 tab.`,
    errorCodeName: 'DOC_DETAILS_BLANK_ERR',
  },
  {
    description: `4) Click on 'Save Data to GSTN' button on the GSTR1 tab to save Document Details. Wait for the save request to complete. You can check status of document details on the View tab.`,
    errorCodeName: 'DOC_DETAILS_BLANK_ERR',
  },

  { description: '', errorCodeName: 'SAVE_REQUEST_IN_PROGRESS_ERR' },
];

export const AdditionalFilters = [
  { value: 'ctin', label: 'Counterparty GSTIN' },
  { value: 'cname', label: 'Name of Counterparty' },
  { value: 'inumList', label: 'Invoice No / Document No' },
  { value: 'val', label: 'Invoice Val / Document Val' },
  { value: 'branchCode', label: 'Branch Code' },
  { value: 'plantCode', label: 'Plant Code' },
  { value: 'divCode', label: 'Division Code' },
  { value: 'userName', label: 'Assigned User' },
  { value: 'etin', label: 'GSTIN of E-commerce', tabs: ['SUPECOMA'] },
  { value: 'etin', label: 'GSTIN of Supplier', tabs: ['ECOMURP', 'ECOM'] },
  // { value: 'irnNum', label: 'IRN Number' },
];

export const AdditionalFiltersEinvoices = [
  { value: 'ctin', label: 'Counterparty GSTIN' },
  { value: 'docNo', label: 'Document number' },
  { value: 'irnNo', label: 'IRN Number' },
];

export const INVOICE_LEVEL_FILTERS_GSTR6 = [
  {
    label: 'From Date',
    inputType: 'date',
    isSelected: false,
    key: 'fromDate',
  },
  {
    label: 'To Date',
    inputType: 'date',
    isSelected: false,
    key: 'toDate',
  },
  {
    label: 'Document Type',
    inputType: 'dropdown',
    isSelected: false,
    dropdownOptions: [...DOCUMENT_TYPE_GSTR6],
    key: 'dty',
  },
  {
    label: 'Counterparty GSTIN',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'GSTINs to be provided in a list without comma',
    splitter: '\n',
    key: 'ctin',
  },
  {
    label: 'Name of Counterparty',
    inputType: 'text',
    isSelected: false,
    key: 'cname',
  },
  {
    label: 'Uploaded on',
    inputType: 'date',
    isSelected: false,
    key: 'uploadedOn',
  },
  {
    label: 'Invoice No / Document No',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'Inv/Doc No to be provided in a list without comma',
    splitter: '\n',
    key: 'inumList',
  },
  {
    label: 'Invoice Val / Document Val',
    inputType: 'text',
    isSelected: false,
    allowOnlyNumbers: true,
    key: 'val',
  },
  {
    label: 'Branch Code',
    inputType: 'text',
    isSelected: false,
    key: 'branchCode',
  },
  {
    label: 'Division Code',
    inputType: 'text',
    isSelected: false,
    infoText: 'Comma separated Div Codes',
    splitter: ',',
    key: 'divCode',
  },
];

export const INVOICE_LEVEL_FILTERS = [
  {
    label: 'From Date',
    inputType: 'date',
    isSelected: false,
    key: 'fromDate',
  },
  {
    label: 'To Date',
    inputType: 'date',
    isSelected: false,
    key: 'toDate',
  },
  {
    label: 'Document Type',
    inputType: 'dropdown',
    isSelected: false,
    dropdownOptions: [...DOCUMENT_TYPE],
    key: 'dty',
  },
  {
    label: 'Document Status',
    inputType: 'dropdown',
    isSelected: false,
    dropdownOptions: [...DOCUMENT_STATUS],
    key: 'dst',
  },
  {
    label: 'Reconciliation Category',
    inputType: 'multi',
    isSelected: false,
    options: [
      {
        label: 'MATCH',
        value: 'MATCH',
      },
      {
        label: 'MISMATCH',
        value: 'MISMATCH',
      },
      {
        label: 'ONLY IRN',
        value: 'ONLY IRN',
      },
      {
        label: 'NO IRN',
        value: 'NO IRN',
      },
    ],
    key: 'einvReconCategory',
  },
  {
    label: 'Uploaded on',
    inputType: 'date',
    isSelected: false,
    key: 'uploadedOn',
  },
  {
    label: 'Nature of Supply through Ecom',
    inputType: 'dropdown',
    isSelected: false,
    dropdownOptions: [...NATURE_OF_SUPPLY_TYPE],
    key: 'suptyp',
  },
  {
    label: 'Counterparty GSTIN',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'GSTINs to be provided in a list without comma',
    splitter: '\n',
    key: 'ctin',
  },
  {
    label: 'Invoice No / Document No',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'Inv/Doc No to be provided in a list without comma',
    splitter: '\n',
    key: 'inumList',
  },
  {
    label: 'Name of Counterparty',
    inputType: 'text',
    isSelected: false,
    key: 'cname',
  },
  {
    label: 'Invoice Val / Document Val',
    inputType: 'text',
    isSelected: false,
    allowOnlyNumbers: true,
    key: 'val',
  },
  {
    label: 'Branch Code',
    inputType: 'text',
    isSelected: false,
    key: 'branchCode',
  },
  {
    label: 'Plant Code',
    inputType: 'text',
    isSelected: false,
    key: 'plantCode',
  },
  {
    label: 'Division Code',
    inputType: 'text',
    isSelected: false,
    infoText: 'Comma separated Div Codes',
    splitter: ',',
    key: 'divCode',
  },
  {
    label: 'Assigned User',
    inputType: 'text',
    isSelected: false,
    infoText: 'Comma separated Assigned User',
    splitter: ',',
    key: 'userName',
  },
];

export const GSTR6_B2B_BASIC_FILTERS = [
  {
    label: 'From Date',
    inputType: 'date',
    isSelected: false,
    key: 'fromDate',
  },
  {
    label: 'To Date',
    inputType: 'date',
    isSelected: false,
    key: 'toDate',
  },
  {
    label: 'Counterparty GSTIN',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'GSTINs to be provided in a list without comma',
    splitter: '\n',
    key: 'ctin',
  },
  {
    label: 'Counterparty Filing Status (Y/N)',
    isSelected: false,
    inputType: 'dropdown',
    key: 'cfs',
    dropdownOptions: [
      { name: 'Yes', value: 'Y' },
      { name: 'No', value: 'N' },
    ],
  },
  {
    label: 'Error',
    inputType: 'dropdown',
    isSelected: false,
    key: 'hasError',
    dropdownOptions: [
      { name: 'Yes', value: 'Y' },
      { name: 'No', value: 'N' },
    ],
  },
  {
    label: 'Invoice Number',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'Inv/Doc No to be provided in a list without comma',
    splitter: '\n',
    key: 'inum',
  },
  {
    label: 'User Action',
    inputType: 'multi',
    isSelected: false,
    key: 'action',
    options: [
      { value: 'A', label: 'Accept', checked: false },
      { value: 'R', label: 'Rejected', checked: false },
      { value: 'P', label: 'Pending', checked: false },
      { value: 'S', label: 'Save to GSTN', checked: false },
      { value: 'N', label: 'No Action Taken', checked: false },
    ],
  },
  {
    label: 'Division Code',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'Comma separated Div Codes',
    splitter: ',',
    key: 'divCodes',
  },
  {
    label: 'GSTIN Status',
    inputType: 'dropdown',
    isSelected: false,
    key: 'gstinStatus',
    dropdownOptions: [
      { value: 1, name: 'Saved' },
      { value: 2, name: 'To be Saved' },
    ],
  },
];

export const GSTR6_B2B_ADDITIONAL_FILTERS = [
  {
    key: 'invoiceValTolerance',
    label: 'Difference Invoice Value',
    inputType: 'text',
    isSelected: false,
  },
  {
    key: 'taxValTolerance',
    label: 'DifferenceTaxable Value',
    inputType: 'text',
    isSelected: false,
  },
  {
    key: 'cgstTolerance',
    label: 'Difference CGST',
    inputType: 'text',
    isSelected: false,
  },
  {
    key: 'sgstTolerance',
    label: 'Difference SGST',
    inputType: 'text',
    isSelected: false,
  },
  {
    key: 'igstTolerance',
    label: 'Difference IGST',
    inputType: 'text',
    isSelected: false,
  },
  {
    key: 'csgstTolerance',
    label: 'Difference CESS',
    inputType: 'text',
    isSelected: false,
  },
  {
    key: 'posDiffer',
    label: 'Difference in POS',
    inputType: 'dropdown',
    isSelected: false,
    dropdownOptions: [
      { name: 'Yes', value: 'Y' },
      { name: 'No', value: 'N' },
    ],
  },
  {
    key: 'rtdiffer',
    label: 'Difference in Tax Rate',
    inputType: 'dropdown',
    isSelected: false,
    dropdownOptions: [
      { name: 'Yes', value: 'Y' },
      { name: 'No', value: 'N' },
    ],
  },
];

export const GSTR6_CDN_BASIC_FILTERS = [
  {
    label: 'Counterparty GSTIN',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'GSTINs to be provided in a list without comma',
    splitter: '\n',
    key: 'ctin',
  },
  {
    label: 'Counterparty Filing Status (Y/N)',
    isSelected: false,
    inputType: 'dropdown',
    key: 'cfs',
    dropdownOptions: [
      { name: 'Yes', value: 'Y' },
      { name: 'No', value: 'N' },
    ],
  },
  {
    key: 'ntty',
    label: 'Note Type',
    type: 'dropdown',
    isSelected: false,
    dropdownOptions: [
      { name: 'Credit Note', value: 'C' },
      { name: 'Debit Note', value: 'D' },
    ],
  },
  {
    label: 'Note Number',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'Note No to be provided in a list without comma',
    splitter: '\n',
    key: 'inum',
  },
  {
    label: 'Division Code',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'Comma separated Div Codes',
    splitter: ',',
    key: 'divCodes',
  },
  {
    key: 'fromDate',
    label: 'Note From Date',
    type: 'date',
    isSelected: false,
  },
  {
    key: 'toDate',
    label: 'Note To Date',
    type: 'date',
    isSelected: false,
  },
  {
    label: 'Error',
    inputType: 'dropdown',
    isSelected: false,
    key: 'hasError',
    dropdownOptions: [
      { name: 'Yes', value: 'Y' },
      { name: 'No', value: 'N' },
    ],
  },
  {
    label: 'User Action',
    inputType: 'multi',
    isSelected: false,
    key: 'action',
    options: [
      { value: 'A', name: 'Accept', checked: false },
      { value: 'R', name: 'Rejected', checked: false },
      { value: 'P', name: 'Pending', checked: false },
      { value: 'S', name: 'Save to GSTN', checked: false },
      { value: 'N', name: 'No Action Taken', checked: false },
    ],
  },
  {
    key: 'gstinStatus',
    label: 'GSTN Status',
    type: 'dropDown',
    isMutliple: false,
    options: [
      { key: '1', label: 'Saved' },
      { key: '2', label: 'To be Saved' },
      { key: null, label: 'Mark for deletion' },
    ],
  },
];

export const GSTR6_CDN_ADDITIONAL_FILTERS = [
  {
    key: 'invoiceValTolerance',
    label: 'Difference Invoice Value',
    inputType: 'textField',
    isSelected: false,
  },
  {
    key: 'taxValTolerance',
    label: 'DifferenceTaxable Value',
    inputType: 'textField',
    isSelected: false,
  },
  {
    key: 'cgstTolerance',
    label: 'Difference CGST',
    inputType: 'textField',
    isSelected: false,
  },
  {
    key: 'sgstTolerance',
    label: 'Difference SGST',
    inputType: 'textField',
    isSelected: false,
  },
  {
    key: 'igstTolerance',
    label: 'Difference IGST',
    inputType: 'textField',
    isSelected: false,
  },
  {
    key: 'csgstTolerance',
    label: 'Difference CESS',
    inputType: 'textField',
    isSelected: false,
  },
  {
    key: 'posDiffer',
    label: 'Difference in POS',
    inputType: 'dropdown',
    isSelected: false,
    dropdownOptions: [
      { name: 'Yes', value: 'Y' },
      { name: 'No', value: 'N' },
    ],
  },
  {
    key: 'rtdiffer',
    label: 'Difference in Tax Rate',
    inputType: 'dropdown',
    isSelected: false,
    dropdownOptions: [
      { name: 'Yes', value: 'Y' },
      { name: 'No', value: 'N' },
    ],
  },
];

export const SUPPLIER_ECOM_FILTERS = [
  {
    label: 'GSTIN of E-commerce',
    inputType: 'text',
    isSelected: false,
    key: 'etin',
  },
];
export const ECOM_TRANSACTION_FILTERS = [
  {
    label: 'GSTIN of Supplier',
    inputType: 'text',
    isSelected: false,
    key: 'etin',
  },
];

export const EINVOICES_DATA_FILTERS = [
  {
    label: 'Counterparty GSTIN',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'Comma separated CTIN',
    splitter: ',',
    key: 'ctin',
  },
  {
    label: 'Document Number',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'Comma separated Doc No.',
    splitter: ',',
    key: 'docNo',
  },
  {
    label: 'IRN number',
    inputType: 'text',
    isSelected: false,
    key: 'irnNo',
  },
];

export const RECONCILIATION_DATA_FILTERS = [
  {
    label: 'Counterparty GSTIN',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'Comma separated Doc No.',
    splitter: ',',
    key: 'ctin',
  },
  {
    label: 'Document Number',
    inputType: 'textarea',
    isSelected: false,
    infoText: 'Comma separated Doc No.',
    splitter: ',',
    key: 'docNo',
  },
  {
    label: 'IRN number',
    inputType: 'text',
    isSelected: false,
    key: 'irnNo',
  },
];

export const INVOICE_FORM_KEYS = [
  'gstin',
  'dty',
  'invTyp',
  'dst',
  'splyTy',
  'inum',
  'idt',
  'rchrg',
  'noteDate',
  'rsn',
  'pgst',
  'pos',
  'val',
  'noteNum',
  'supTyp',
];

export const COUNTERPARTY_FORM_KEYS = ['cname', 'ctpy', 'ctin', 'statecd'];

export const ORIGINAL_DATA_FORM_KEYS = [
  'ontNum',
  'ontDt',
  'oinum',
  'oidt',
  'octpy',
  'octin',
  'ostatecd',
];

export const SHIPPING_BILL_FORM_KEYS = ['sbnum', 'sbdt', 'sbpcode'];

export const PROVISIONAL_ASSESSMENT_FORM_KEYS = ['odnum', 'oddt', 'etin', 'prs', 'omon'];

export const ECOM_DETAILS_FORM_KEYS = ['gstin', 'supTyp', 'recty', 'stin', 'rtin', 'dst'];

export const STATUS_ORDER = [
  'NO_DATA',
  'PENDING_FOR_CREATE_GSTR1',
  'DRAFT',
  'SAVE',
  'FILED',
];

export const GENERIC_FORM_KEYS = [
  'fy',
  'refnum',
  'pdt',
  'ivst',
  'cptycde',
  'txp',
  'gen1',
  'gen2',
  'gen3',
  'gen4',
  'gen5',
  'gen6',
  'gen7',
  'gen8',
  'gen9',
  'gen10',
  'gen11',
  'gen12',
  'gen13',
  'gen14',
  'gen15',
];

export const SUPPLY_TYPE = [
  { label: 'Inter', value: 'INTER' },
  { label: 'Intra', value: 'INTRA' },
];

export const COUNTERPARTY_TYPE = [
  { label: 'Registered', value: 'R' },
  { label: 'Unregistered', value: 'U' },
];

export const PREGSTREGIME = [
  { label: 'Yes', value: 'Y' },
  { label: 'No', value: 'N' },
];

export const DIFF_PERCENT = [
  { label: 'BLANK', value: 'BLANK' },
  { label: '0.65', value: '0.65' },
];

export const POS_LIST = [
  { label: '01 - Jammu & Kashmir', value: '01' },
  { label: '02 - Himachal Pradesh', value: '02' },
  { label: '03 - Punjab', value: '03' },
  { label: '04 - Chandigarh', value: '04' },
  { label: '05 - Uttarakhand', value: '05' },
  { label: '06 - Haryana', value: '06' },
  { label: '07 - Delhi', value: '07' },
  { label: '08 - Rajasthan', value: '08' },
  { label: '09 - Uttar Pradesh', value: '09' },
  { label: '10 - Bihar', value: '10' },
  { label: '11 - Sikkim', value: '11' },
  { label: '12 - Arunachal Pradesh', value: '12' },
  { label: '13 - Nagaland', value: '13' },
  { label: '14 - Manipur', value: '14' },
  { label: '15 - Mizoram', value: '15' },
  { label: '16 - Tripura', value: '16' },
  { label: '17 - Meghalaya', value: '17' },
  { label: '18 - Assam', value: '18' },
  { label: '19 - West Bengal', value: '19' },
  { label: '20 - Jharkhand', value: '20' },
  { label: '21 - Odisha', value: '21' },
  { label: '22 - Chhattisgarh', value: '22' },
  { label: '23 - Madhya Pradesh', value: '23' },
  { label: '24 - Gujarat', value: '24' },
  { label: '26 - Daman & Diu, Dadra & Nagar Haveli', value: '26' },
  { label: '27 - Maharashtra', value: '27' },
  { label: '29 - Karnataka', value: '29' },
  { label: '30 - Goa', value: '30' },
  { label: '31 - Lakshadweep', value: '31' },
  { label: '32 - Kerala', value: '32' },
  { label: '33 - Tamil Nadu', value: '33' },
  { label: '34 - Pondicherry', value: '34' },
  { label: '35 - Andaman & Nicobar Islands', value: '35' },
  { label: '36 - Telangana', value: '36' },
  { label: '37 - Andhra Pradesh', value: '37' },
  { label: '38 - Ladakh', value: '38' },
  { label: '96 - Other Country', value: '96' },
  { label: '97 - Other Territory', value: '97' },
];

export const REVERSE_CHARGE = [
  { label: 'Yes', value: 'Y' },
  { label: 'No', value: 'N' },
];

export const ISPAID_UNDER_PROVISIONAL_ASSESSMENT = [
  { label: 'Yes', value: 'Y' },
  { label: 'No', value: 'N' },
];

export const NATURE_SUPPLY_TYPE = [
  { label: 'Ecom52', value: 'Ecom52' },
  { label: 'Ecom9(5)', value: 'Ecom9(5)' },
];

export const TYPE_GOODS_SERVICES = [
  { label: 'Goods', value: 'G' },
  { label: 'Services', value: 'S' },
];

export const UQC_LIST = [
  { label: 'BAGS', value: 'BAG' },
  { label: 'BALE', value: 'BAL' },
  { label: 'BUNDLES', value: 'BDL' },
  { label: 'BUCKLES', value: 'BKL' },
  { label: 'BILLION OF UNITS', value: 'BOU' },
  { label: 'BOX', value: 'BOX' },
  { label: 'BOTTLES', value: 'BTL' },
  { label: 'BUNCHES', value: 'BUN' },
  { label: 'CANS', value: 'CAN' },
  { label: 'CUBIC METERS', value: 'CBM' },
  { label: 'CUBIC CENTIMETERS', value: 'CCM' },
  { label: 'CENTIMETERS', value: 'CMS' },
  { label: 'CARTONS', value: 'CTN' },
  { label: 'DOZENS', value: 'DOZ' },
  { label: 'DRUMS', value: 'DRM' },
  { label: 'GREAT GROSS', value: 'GGK' },
  { label: 'GRAMMES', value: 'GMS' },
  { label: 'GROSS', value: 'GRS' },
  { label: 'GROSS YARDS', value: 'GYD' },
  { label: 'KILOGRAMS', value: 'KGS' },
  { label: 'KILOLITRE', value: 'KLR' },
  { label: 'KILOMETRE', value: 'KME' },
  { label: 'MILILITRE', value: 'MLT' },
  { label: 'METERS', value: 'MTR' },
  { label: 'METRIC TON', value: 'MTS' },
  { label: 'NUMBERS', value: 'NOS' },
  { label: 'PACKS', value: 'PAC' },
  { label: 'PIECES', value: 'PCS' },
  { label: 'PAIRS', value: 'PRS' },
  { label: 'QUINTAL', value: 'QTL' },
  { label: 'ROLLS', value: 'ROL' },
  { label: 'SETS', value: 'SET' },
  { label: 'SQUARE FEET', value: 'SQF' },
  { label: 'SQUARE METERS', value: 'SQM' },
  { label: 'SQUARE YARDS', value: 'SQY' },
  { label: 'TABLETS', value: 'TBS' },
  { label: 'TEN GROSS', value: 'TGM' },
  { label: 'THOUSANDS', value: 'THD' },
  { label: 'TONNES', value: 'TON' },
  { label: 'TUBES', value: 'TUB' },
  { label: 'US GALLONS', value: 'UGS' },
  { label: 'UNITS', value: 'UNT' },
  { label: 'YARDS', value: 'YDS' },
  { label: 'OTHERS', value: 'OTH' },
];

export const RATE_LIST = [
  { label: 'No Value', value: null },
  { label: '0', value: '0' },
  { label: '0.1', value: '0.1' },
  { label: '0.25', value: '0.25' },
  { label: '3', value: '3' },
  { label: '5', value: '5' },
  { label: '12', value: '12' },
  { label: '18', value: '18' },
  { label: '28', value: '28' },
  { label: '7.5', value: '7.5' },
  { label: '1', value: '1' },
  { label: '1.5', value: '1.5' },
];

export const IRT_LIST = [
  { label: 'No Value', value: null },
  { label: '0', value: '0' },
  { label: '0.1', value: '0.1' },
  { label: '0.25', value: '0.25' },
  { label: '3', value: '3' },
  { label: '5', value: '5' },
  { label: '12', value: '12' },
  { label: '18', value: '18' },
  { label: '28', value: '28' },
  { label: '7.5', value: '7.5' },
  { label: '1', value: '1' },
  { label: '1.5', value: '1.5' },
  { label: '40', value: '40' },
];

export const CRT_LIST = [
  { label: 'No Value', value: null },
  { label: '0', value: '0' },
  { label: '0.05', value: '0.05' },
  { label: '0.125', value: '0.125' },
  { label: '1.5', value: '1.5' },
  { label: '2.5', value: '2.5' },
  { label: '6', value: '6' },
  { label: '9', value: '9' },
  { label: '14', value: '14' },
  { label: '3.75', value: '3.75' },
  { label: '0.5', value: '0.5' },
  { label: '0.75', value: '0.75' },
  { label: '20', value: '20' },
];

export const SRT_LIST = [
  { label: 'No Value', value: null },
  { label: '0', value: '0' },
  { label: '0.05', value: '0.05' },
  { label: '0.125', value: '0.125' },
  { label: '1.5', value: '1.5' },
  { label: '2.5', value: '2.5' },
  { label: '6', value: '6' },
  { label: '9', value: '9' },
  { label: '14', value: '14' },
  { label: '3.75', value: '3.75' },
  { label: '0.5', value: '0.5' },
  { label: '0.75', value: '0.75' },
  { label: '20', value: '20' },
];

export const TAX_APPLICABILITY = [
  { label: 'Taxable', value: 'T' },
  { label: 'Nil', value: 'L' },
  { label: 'Exempt', value: 'E' },
  { label: 'Non GST', value: 'N' },
  { label: 'Free Supplies', value: 'F' },
];
